import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@img/icon_vip.svg'
import _imports_1 from '@img/icon-gold.png'
import _imports_2 from '@/assets/img/vip@2x.png'
import _imports_3 from '@img/icon-sharer.png'


const _withScopeId = n => (_pushScopeId("data-v-0a7c0aa8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-game-box" }
const _hoisted_2 = { class: "header-img" }
const _hoisted_3 = { alt: "" }
const _hoisted_4 = { class: "game-desc" }
const _hoisted_5 = { class: "game-name ellipsis" }
const _hoisted_6 = {
  key: 0,
  class: "game-content ellipsis2"
}
const _hoisted_7 = { class: "price-min" }
const _hoisted_8 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "bg-exc"
}
const _hoisted_12 = {
  key: 1,
  class: "vipexc flex justify-center items-center"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-20 h-20 inline-block mr-3",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_14 = {
  key: 0,
  class: "tips"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_16 = { class: "username" }
const _hoisted_17 = { class: "tips-content" }

import {
  ref,
  toRefs,
  watchEffect,
  watch,
  reactive,
  toRef,
} from "vue";
import { Popover, message } from "ant-design-vue";
import CusModal from "@/components/CusModal/index.vue";
import {
  apiGetCommunityDetail,
  apiGetNewGameLibrary,
  apiSearchCommunity,
} from "@api/gamelibs";
import { useloginStore } from "@/store/login";
import { useGameListStore } from "@/store/gameList";
import { useVipStore } from "@/store/vip";
import { useRoute, useRouter } from "vue-router";
import { isLogin } from "@js/account";
import BusinessManager from "@js/controls";
import { formatFloatNum } from "@js/utils";
import { useTurnVipStore } from "@/store/turnVip";
import type { yunpb } from "@/types/protobuf";
import { trackCustomizeEvent } from "@/js/stastic";
interface Props {
  communityId: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    communityId: null
  },
  emits: ["selectGameModelClose"],
  setup(__props: any, { emit }) {

const props = __props as {
  communityId: any;
};


let selectGameData: yunpb.ICommunityDetail = reactive({});

const isShowSelectGameModal = ref(false);

const isShowScrollMask = ref(false);
const loginStore = useloginStore();
const turnVip = useTurnVipStore();
const vipStore = useVipStore();
const gameListStore = useGameListStore();
const sectionBoxDom = ref(null);
const route = useRoute();
const router = useRouter();

// 从游戏列表中选中游戏
const selectGame = async (communityId: number) => {
  if (!isLogin()) {
    loginStore.setIsModalVisable(true);
    return;
  }
  try {
    selectGameData = {};
    const res = await apiGetCommunityDetail({ communityId });
    if (res?.data) {
      selectGameData = res.data;
      isShowSelectGameModal.value = true;
      setTimeout(bindEventOnScrollMask);
      console.log("selectGame", res);
    } else {
      console.log("没有游戏？？？", res?.data);
    }
  } catch (err: any) {
    message.error(err?.rpcOut?.desc || "load fail");
    console.error(err);
  }
};

const communityIdRef = ref(props.communityId);

watch(toRef(props, "communityId"), (newValue, oldValue) => {
  console.log("communityId 变化了", newValue, oldValue);
  if (newValue !== oldValue && !newValue) {
    sectionBoxDom.value?.removeEventListener(
      "scroll",
      bindEventOnScrollMaskScroll
    );
    isShowSelectGameModal.value = false;
  } else {
    selectGame(props.communityId);
  }
});

const bindEventOnScrollMaskScroll = (e: any) => {
  isShowScrollMask.value =
    e.target.scrollTop + e.target.offsetHeight < e.target.scrollHeight - 5;
};

// 为云游戏列表滚动内的滚动遮罩添加事件
const bindEventOnScrollMask = () => {
  if (!selectGameData.gameInfo!.cloudGameList!.length!) return;
  console.log("data.sectionBoxDom", sectionBoxDom.value);
  // 默认显示
  isShowScrollMask.value = true;
  sectionBoxDom.value.scrollTop = 0;
  sectionBoxDom.value.addEventListener("scroll", bindEventOnScrollMaskScroll);
};

// 关闭选中游戏弹窗
const selectGameModelClose = () => {
  sectionBoxDom.value?.removeEventListener(
    "scroll",
    bindEventOnScrollMaskScroll
  );
  emit("selectGameModelClose");
  isShowSelectGameModal.value = false;
};

// 根据用户当前vip等级获取对应的游戏金币价格
const getGameGoldsByVipType = (cloudGame: any) => {
  // const curPrices = loginStore.userInfo?.vipInfo?.vipLevelType
  //   ? cloudGame.prices!.find((val: any) => val.priceType! > 1)
  //   : cloudGame.prices!.find((val: any) => val.priceType === 1);
  // vipLevelType > 0 就是 vip队列  1是普通队列 2是快速队列 3是vip队列 这里只显示 普通队列 或者 vip队列
  const curPrices = loginStore.userInfo?.vipInfo?.vipLevelType
    ? cloudGame.prices!.find((val: any) => val.priceType === 3)
    : cloudGame.prices!.find((val: any) => val.priceType === 1);

  return curPrices?.price;
};

// 购买商品处理函数
const handlePayGoods = (item: any) => {
  console.log(
    "购买游戏？？？",
    item,
    item.isVipExclusiveGame,
    loginStore.userInfo.vipInfo,
    vipStore
  );
  if (item.isVipExclusiveGame && !vipStore.vipType) {
    turnVip.update_isShowTurnVipModal({
      isShow: true,
      vipType: vipStore.vipType,
      needTypeVip: 7,
    });
    trackCustomizeEvent({
      event_id: "home_vip_exclusive_game_dialog",
      cloudGameId: item.communityId,
    });
    return;
  }
  // 3 是维护中
  if (item.gameStatus === 3) return;
  // 检查是否已购买
  if (!item.isNeedBuy) {
    // 再检查用户的金币是否足够玩游戏
    const gameGolds = getGameGoldsByVipType(item);
    if (loginStore.golds < gameGolds) {
      handleChangeCoinNotEnoughModal(true);
      return;
    }
    handlePlayGame(item.cloudGameId);
    return;
  }
  // 目前来说，只有这个地方是商品详情页的唯一入口，跳转前标记未购买状态，方便后续监听变化来购买刷新状态
  gameListStore.update_isBuyGoodSuccess(false);
  const target = router.resolve({
    path: "/GoodsDetail",
    query: {
      goods_id: item.goodsId,
      from: "GameGroupBuy",
    },
  });
  window.open(target.href, "_blank");
};
// 展示金币不够的弹窗
const showCoinNotEnoughModal = ref(false);
const handleChangeCoinNotEnoughModal = (show: boolean) => {
  showCoinNotEnoughModal.value = show;
};
//进入游戏排队
const handlePlayGame = async (gameId: number) => {
  const res = await BusinessManager.GetGameRoomInfo(gameId);
  console.log("游戏排队", res);

  const gameInfo = res && res.obj;
  // 启动游戏时关闭弹窗
  // isShowSelectGameModal.value = false;
  window.gameStateMgr.playGame(gameInfo);
  selectGameModelClose(); // 将isShowSelectGameModal 换为 selectGameModelClose
  // playGameStore.handlePlayGameMessage(gameInfo);
};
const handleShowRecharge = () => {
  showCoinNotEnoughModal.value = false;
  loginStore.update_isShowRecharge(true);
};

return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CusModal, {
      width: "600px",
      onOnClose: selectGameModelClose,
      isShow: isShowSelectGameModal.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [
              [_directive_lazy, _unref(selectGameData)?.gameInfo?.gameImage]
            ])
          ]),
          (_unref(selectGameData).gameInfo.cloudGameList.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["section-box", { scroll: _unref(selectGameData).gameInfo.cloudGameList.length > 3 }]),
                ref_key: "sectionBoxDom",
                ref: sectionBoxDom
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectGameData).gameInfo.cloudGameList, (cloudGame, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["section relative", { first: !idx, 'bg-exc-vip': cloudGame.isVipExclusiveGame }]),
                    key: cloudGame.cloudGameId
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(cloudGame.cloudGameName), 1),
                      (cloudGame.describe)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(cloudGame.describe), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_7, [
                        (cloudGame.isVipExclusiveGame)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                          : _createCommentVNode("", true),
                        _hoisted_9,
                        _createElementVNode("span", null, _toDisplayString(getGameGoldsByVipType(cloudGame)
                    ? getGameGoldsByVipType(cloudGame) + "/min"
                    : "Free"), 1)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["btn active-btn relative", { 'game-maintain': cloudGame.gameStatus === 3 }]),
                      onClick: ($event: any) => (handlePayGoods(cloudGame))
                    }, [
                      (cloudGame.discount && cloudGame.isNeedBuy)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "discount",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(Math.trunc(cloudGame.discount)) + "%", 1)
                          ]))
                        : _createCommentVNode("", true),
                      (cloudGame.gameStatus === 3)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("SelectGameModal.Under")), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(//          需要购买且不忽略需要购买时
                //            cloudGame.isNeedBuy && !cloudGame.isSkipNeedBuy
                cloudGame.isNeedBuy
                  ? `$ ${_unref(formatFloatNum)(cloudGame.price / 100)}`
                  : "play"), 1)
                          ], 64))
                    ], 10, _hoisted_10),
                    (cloudGame.isVipExclusiveGame)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                      : _createCommentVNode("", true),
                    (cloudGame.isVipExclusiveGame)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("SelectGameModal.Exclusive")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ], 2))
            : _createCommentVNode("", true),
          (_unref(selectGameData).gameInfo.cloudGameList.length > 3)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["scroll-mask", { isShow: isShowScrollMask.value }])
              }, null, 2))
            : _createCommentVNode("", true),
          _createVNode(_unref(Popover), {
            trigger: "hover",
            placement: "top",
            overlayClassName: "avatar-popover",
            color: "#292929"
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createTextVNode(_toDisplayString(_ctx.$t("SelectGameModal.content")) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(_unref(selectGameData).gameInfo.cloudGameList[0]?.shareUserName), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("SelectGameModal.content1")) + " ", 1)
              ])
            ]),
            default: _withCtx(() => [
              (_unref(selectGameData).gameInfo.cloudGameList[0]?.shareUserName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("SelectGameModal.tips")) + " ", 1),
                    _hoisted_15,
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(selectGameData).gameInfo.cloudGameList[0]?.shareUserName), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["isShow"]),
    _createVNode(CusModal, {
      isShow: showCoinNotEnoughModal.value,
      title: "",
      content: _ctx.$t('showCoinNotEnoughModal.content'),
      cancelText: _ctx.$t('showCoinNotEnoughModal.later'),
      okText: _ctx.$t('Payment.recharge'),
      onOnCancel: _cache[1] || (_cache[1] = ($event: any) => (handleChangeCoinNotEnoughModal(false))),
      onOnClose: _cache[2] || (_cache[2] = ($event: any) => (handleChangeCoinNotEnoughModal(false))),
      onOnConfirm: handleShowRecharge
    }, null, 8, ["isShow", "content", "cancelText", "okText"])
  ], 64))
}
}

})